import React from "react";
import { Box, Flex, Text } from "@chakra-ui/react";
import { Trans } from "react-i18next";

/**
 * 지표 카드 4장은 개편 시안에서 히어로 검정 영역 안으로 들어갔다.
 * (@/features/landing/components/FeatureSummaryCards)
 * 이 섹션에는 히어로 바로 아래의 문구만 남는다.
 */
function LadingPageFeatureSummarySection() {
  return (
    <Box
      as={"section"}
      aria-labelledby={"landing-summary-title"}
      paddingX={{
        base: "16px",
        lg: "24px",
        xl: "320px",
      }}
    >
      <Flex
        maxWidth={"1318px"}
        margin={"0 auto"}
        justifyContent={"center"}
        paddingTop={{
          base: "60px",
          lg: "120px",
        }}
        paddingBottom={{
          base: "60px",
          lg: "80px",
        }}
      >
        <Text
          fontSize={{
            base: "28px",
            lg: "48px",
          }}
          fontWeight={700}
          lineHeight={{
            base: "38px",
            lg: "68px",
          }}
          textAlign={"center"}
          as={"h2"}
          id={"landing-summary-title"}
        >
          <Trans
            i18nKey={"landing:summary.title"}
            components={{
              br: (
                <Box
                  as={"span"}
                  display={{
                    base: "none",
                    md: "block",
                  }}
                />
              ),
            }}
          />
        </Text>
      </Flex>
    </Box>
  );
}

export default LadingPageFeatureSummarySection;
